import { render, staticRenderFns } from "./RegLeishmaniasiList.vue?vue&type=template&id=4cb176df"
import script from "./RegLeishmaniasiList.vue?vue&type=script&lang=js"
export * from "./RegLeishmaniasiList.vue?vue&type=script&lang=js"
import style0 from "./RegLeishmaniasiList.vue?vue&type=style&index=0&id=4cb176df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports